type Tone = 'success' | 'warning' | 'danger' | 'info' | 'muted' | 'neutral'

// Full status -> tone map (ported from the design's chip() function).
const MAP: Record<string, Tone> = {
  // maker-checker
  Draft: 'neutral', 'Pending approval': 'warning', 'In review': 'info', Approved: 'success', Rejected: 'danger', Returned: 'warning',
  // investment / account
  Active: 'success', Matured: 'info', Maturing: 'warning', Suspended: 'danger', Dormant: 'neutral', Closed: 'neutral', Onboarding: 'info', Blocked: 'danger',
  // payments / recon
  Unmatched: 'danger', Suspense: 'warning', Matched: 'success', Reconciled: 'success', Unreconciled: 'warning', 'Partial match': 'warning',
  // kyc
  Verified: 'success', 'Pending review': 'warning', Incomplete: 'danger', 'Grace period': 'warning', Grace: 'warning',
  // funds
  Priced: 'success', 'Pricing due': 'warning', Uploaded: 'success', Missing: 'danger',
  // cases
  Open: 'info', Escalated: 'danger', Confirmed: 'danger', 'False-positive': 'neutral', Whitelisted: 'muted', Cleared: 'success',
  // severity
  Critical: 'danger', High: 'danger', Medium: 'warning', Low: 'neutral',
  // risk
  'High risk': 'danger', 'Med risk': 'warning', 'Low risk': 'success',
  // filing
  'MLRO review': 'warning', Filed: 'info', Acknowledged: 'success',
  // freeze
  'Active freeze': 'danger', Released: 'neutral',
  // orders
  Filled: 'success', Sent: 'info', Settled: 'success', Allocated: 'info', Scheduled: 'muted', Failed: 'danger', Reversed: 'neutral', Pending: 'warning',
  // payment-rail lifecycle (transactions_out / stk / balance)
  Received: 'muted', Submitted: 'info', Delivered: 'success', Reversing: 'warning', Success: 'success',
  // derived payout attention states
  Stuck: 'danger', Reconciling: 'warning',
}

const COLOR: Record<Tone, string> = {
  success: 'var(--success)', warning: 'var(--warning)', danger: 'var(--danger)',
  info: 'var(--info)', muted: 'var(--muted)', neutral: 'var(--text-2)',
}

export function StatusChip({ status, tone }: { status: string; tone?: Tone }) {
  const c = COLOR[tone ?? MAP[status] ?? 'neutral']
  return (
    <span className="chip" style={{ color: c, borderColor: `color-mix(in oklab, ${c} 30%, transparent)`, background: `color-mix(in oklab, ${c} 12%, transparent)` }}>
      <span className="cdot" style={{ background: c }} />
      {status}
    </span>
  )
}
